// companydata
export const LOAD_COMPANYDATA = '🏢 Load companyData'
export const FETCH_COMPANYDATA_PENDING = '🕐 Fetch companyData pending'
export const FETCH_COMPANYDATA_SUCCESS = '✅ Fetch companyData success'
export const FETCH_COMPANYDATA_FAILURE = '❌ Fetch companyData failure'
export const LOAD_COUNTRYCODES = '☎ Load Countrycodes'

// currentuser
export const LOAD_CURRENTUSER = '🙋‍♂️ Load currentUser'
export const FETCH_CURRENTUSER_PENDING = '🕐 Fetch currentUser pending'
export const FETCH_CURRENTUSER_SUCCESS = '✅ Fetch currentUser success'
export const FETCH_CURRENTUSER_FAILURE = '❌ Fetch currentUser failure'

export const LOAD_CURRENTUSER_COMPANIES = 'load_users_companies'
export const LOAD_CURRENTUSER_DEPARTMENTS = 'load_users_departments'
export const PATCH_CURRENTUSER_DEPARTMENTS = 'patch_user_departments'
export const RESET_CACHED_USERDEPARTMENTS = 'reset_cached_user_departments'

// positions
export const LOAD_POSITIONS = 'load_positions'

// groups
export const LOAD_GROUPS = 'load_groups'

// locale
export const TRIGGER_CONTENT_LOCALE_UPDATE = 'trigger_content_locale_update'
